import { Project } from '../models/project';
import { CONSTANTS } from '../constants/constant';

const personalProjectNameSuffix = /\([A-Za-z0-9]{8,}\)\s*$/;

export const isPersonalProject = (project?: Pick<Project, 'name' | 'identifiers'> | null): boolean =>
  !!project &&
  (!!project.identifiers?.includes(CONSTANTS.mcsAutomation) ||
    personalProjectNameSuffix.test(project.name ?? ''));